/**
 * SmoothScroll for lbbw-am.de
 *
 * @author Florian Gutwald
 * Converted to Plain JS for Rollup
 */
export default class SmoothScroll {
  /**
   * @param {HTMLElement} element - Der Link, der das Scrollen auslöst
   * @param {Object} options
   */
  constructor(element, options = {}) {
    this.element = element;
    this.settings = Object.assign({
      time: 500,
      offsetElement: '#header'
    }, options);

    this.init();
  }

  init() {
    this.element.addEventListener('click', (event) => {
      const href = this.element.getAttribute('href');

      // Prüfen ob es ein interner Anker-Link ist
      if (href && href.startsWith('#') && href.length > 1) {
        const targetElement = document.querySelector(href);

        if (targetElement) {
          event.preventDefault();
          this.scrollTo(targetElement);
        }
      }
    });
  }

  /**
   * Scrollt zum Ziel-Element unter Berücksichtigung der Header-Höhe
   * @param {HTMLElement} target
   */
  scrollTo(target) {
    const header = document.querySelector(this.settings.offsetElement);
    const headerHeight = header ? header.offsetHeight : 0;
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: targetPosition - headerHeight,
      behavior: 'smooth'
    });
  }
}

/**
 * Hilfsfunktion zur Massen-Initialisierung
 */
export function initSmoothScroll(selector = '.js_smooth') {
  const links = document.querySelectorAll(selector);
  links.forEach(link => new SmoothScroll(link));
}